export default {
  how_to_place_order: {
    header: 'Comment passer une commande ?',
    body: 'Parcourez le menu, ajoutez des articles à votre panier et suivez les étapes de paiement. Vous recevrez une confirmation une fois la commande passée.',
  },
  schedule_order: {
    header: "Puis-je planifier une commande à l'avance ?",
    body: "Oui ! Lors du paiement, choisissez l'option « Planifier » pour définir une heure de retrait qui vous convient.",
  },
  customize_order: {
    header: 'Puis-je personnaliser ma commande ?',
    body: 'Absolument. Appuyez sur un article du menu pour voir les options de personnalisation telles que les garnitures, accompagnements et préférences.',
  },
  track_order: {
    header: 'Comment suivre ma commande ?',
    body: "Après avoir passé votre commande, suivez les mises à jour en temps réel dans l'application, de la confirmation à la disponibilité pour le retrait.",
  },
  cancel_or_edit_order: {
    header: "Puis-je annuler ou modifier ma commande après l'avoir passée ?",
    body: "Si votre commande n'a pas encore commencé à être préparée, vous pouvez demander des modifications en appelant directement le restaurant via l'application.",
  },
  payment_methods: {
    header: 'Quels modes de paiement acceptez-vous ?',
    body: 'Nous acceptons les principales cartes de crédit/débit, Apple Pay et Google Pay, selon votre appareil.',
  },
  no_confirmation: {
    header: "Je n'ai pas reçu de confirmation. Que dois-je faire ?",
    body: "Vérifiez le dossier spam de votre e-mail ou consultez l'onglet Commandes dans l'application. Si vous ne le voyez toujours pas, contactez directement le restaurant.",
  },
  pickup_instructions: {
    header: 'Où récupérer ma commande ?',
    body: "Les instructions de retrait sont affichées sur l'écran de confirmation et dans le récapitulatif de commande. Repérez la signalisation ou demandez au personnel à votre arrivée.",
  },
  loyalty_points: {
    header: 'Puis-je gagner des points de fidélité avec mes commandes ?',
    body: "Oui, les achats éligibles génèrent automatiquement des points. Consultez votre solde et vos récompenses sur l'écran principal de l'application.",
  },
  apply_promo_code: {
    header: 'Comment appliquer un code promo ou une remise ?',
    body: 'Lors du paiement, vous verrez une option pour saisir un code promo. Les remises disponibles sont également appliquées automatiquement si vous êtes éligible.',
  },
  issue_with_order: {
    header: 'Que faire en cas de problème avec ma commande ?',
    body: "Nous sommes là pour vous aider. Contactez le restaurant via l'application ou le support par e-mail avec l'option Contacter le support.",
  },
  use_loyalty_and_coupon: {
    header: 'Puis-je utiliser des points de fidélité et un coupon (comme 1 acheté = 1 offert) sur la même commande ?',
    body: "Non — une seule remise ou offre peut être appliquée par commande. Cela garantit une utilisation équitable des récompenses et promotions. Choisissez l'option qui vous offre le meilleur avantage !",
  },
};
